import { Action, createReducer, on } from '@ngrx/store';
import { MembershipActions } from './membership.actions';
import { membershipInitialState, MembershipState } from './membership.state';

const _membershipReducer = createReducer(
  membershipInitialState(),

  /**
   * Reducers For Membership
   */

  on(MembershipActions.getAllPlans, (state) => {
    return {
      ...state,
      allPlans: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.getAllPlansSuccess, (state, { membership }) => {
    return {
      ...state,
      allPlans: {
        loading: false,
        data: membership.data,
      },
    };
  }),
  on(MembershipActions.getAllPlansFailure, (state, { failure }) => {
    return {
      ...state,
      allPlans: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Cards
   */

  on(MembershipActions.getAllCards, (state) => {
    return {
      ...state,
      allCards: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.getAllCardsSuccess, (state, { cards }) => {
    return {
      ...state,
      allCards: {
        loading: false,
        data: cards.data,
      },
    };
  }),
  on(MembershipActions.getAllCardsFailure, (state, { failure }) => {
    return {
      ...state,
      allCards: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Delete Card
   */

  on(MembershipActions.deleteCard, (state) => {
    return {
      ...state,
      deleteCard: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.deleteCardSuccess, (state, { response }) => {
    return {
      ...state,
      deleteCard: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(MembershipActions.deleteCardFailure, (state, { failure }) => {
    return {
      ...state,
      deleteCard: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Delete Card
   */
  on(MembershipActions.subscribeToPlan, (state) => {
    return {
      ...state,
      payMembership: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.subscribeToPlanSuccess, (state, { response }) => {
    return {
      ...state,
      payMembership: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(MembershipActions.subscribeToPlanFailure, (state, { failure }) => {
    return {
      ...state,
      payMembership: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Add Card
   */
  on(MembershipActions.addCard, (state) => {
    return {
      ...state,
      addCard: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.addCardSuccess, (state, { response }) => {
    return {
      ...state,
      addCard: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(MembershipActions.addCardFailure, (state, { failure }) => {
    return {
      ...state,
      addCard: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Update Membership
   */
  on(MembershipActions.updateMembership, (state) => {
    return {
      ...state,
      updateMembership: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.updateMembershipSuccess, (state, { response }) => {
    return {
      ...state,
      updateMembership: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(MembershipActions.updateMembershipFailure, (state, { failure }) => {
    return {
      ...state,
      updateMembership: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Cancel Membership
   */

  on(MembershipActions.cancelMembership, (state) => {
    return {
      ...state,
      cancelMembership: {
        loading: true,
      },
    };
  }),
  on(MembershipActions.cancelMembershipSuccess, (state, { response }) => {
    return {
      ...state,
      cancelMembership: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(MembershipActions.cancelMembershipFailure, (state, { failure }) => {
    return {
      ...state,
      cancelMembership: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function membershipReducer(
  state: MembershipState | undefined,
  action: Action
) {
  return _membershipReducer(state, action);
}
